module.exports = __webpack_public_path__ + "img/healthProMobile4.79baf676.png";